import { observer } from "mobx-react-lite"

import { TooltipProvider } from "@/components/tooltip"
import { ClFarmsTableParams } from "@/domains/cl-farms-page/components/cl-farms-table-params/cl-farms-table-params"
import { ClFarmsTable } from "@/domains/cl-farms-page/components/cl-farms-table/cl-farms-table"
import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"

const ClFarmsPage = observer(() => {
  const title = "CL Farms Liquidity"

  return (
    <PageContainer>
      <MetaData title={title} />
      <PageTitle title="CL Farms Liquidity" subTitle="Boosted farming rewards with liquidity automation" />
      <TooltipProvider>
        <div className="text-t100 bg-p400 border-p400-light flex w-full flex-col gap-6 rounded-lg border p-4 lg:p-6">
          <ClFarmsTableParams />
          <ClFarmsTable />
        </div>
      </TooltipProvider>
    </PageContainer>
  )
})

export default ClFarmsPage
